import { LogOut } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/auth";

export const LogoutButton = () => {
  const { logout, user } = useAuth();
  const navigate = useNavigate();

  return (
    <div className="flex items-center gap-3">
      {user?.email && (
        <span
          data-testid="session-user-email"
          className="font-mono-label text-[10px] tracking-[0.1em] text-[#A8A29E] hidden sm:inline"
        >
          {user.email}
        </span>
      )}
      <button
        type="button"
        data-testid="logout-button"
        onClick={() => {
          logout();
          navigate("/login", { replace: true });
        }}
        className="flex items-center gap-1.5 font-mono-label text-[10px] uppercase tracking-[0.2em] text-[#57534E] border border-[#E7E2D7] rounded-full px-3.5 py-2 bg-white/70 hover:border-[#C25E38]/40 hover:text-[#C25E38] transition-colors duration-200 cursor-pointer"
      >
        <LogOut className="h-3 w-3" /> Cerrar sesión
      </button>
    </div>
  );
};
